import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/system/enterprises/$enterpriseId',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/operations/enterprises/$enterpriseId',
      params,
      replace: true,
    });
  },
});
